import { ContractorUserDTO, ContractorUserModel } from '@cast/leadcast-types';
import { BaseService, BaseServiceConstructor } from 'api/services/base.service';

export class ContractorService extends BaseService {
  constructor({ serviceUrls, token, tenantName }: BaseServiceConstructor) {
    super({ serviceUrls, token, tenantName });
  }
  async deleteContractorAssignment(id: string): Promise<void> {
    await this.publicHttpClient.delete(
      `/contractors/users/${id}`,
      {},
      {
        withCredentials: false,
      }
    );
  }

  async updateContractorUserAssignment(
    contractorUserAssignmentId: ContractorUserDTO['id'],
    contractorId: string
  ): Promise<{ id: string }> {
    const response = await this.publicHttpClient.patch<{ id: string }>(
      `/contractors/${contractorId}/users/${contractorUserAssignmentId}`,
      {},
      {
        withCredentials: false,
      }
    );
    return response.data;
  }

  async createContractorUserAssignment(params: {
    userId: string;
    contractorId: string;
  }): Promise<ContractorUserModel> {
    const response = await this.publicHttpClient.post<ContractorUserModel>(
      `/contractors/${params.contractorId}/users`,
      { userId: params.userId },
      {
        withCredentials: false,
      }
    );
    return response.data;
  }
}
